/**
 * Generic skeleton for sections without a specific LoadingFallback.
 *
 * Reserves vertical space with an animate-pulse block. Matches the
 * "minimum reasonable section height" — sections with banner-style real
 * heights (50-200px) should provide their own fallback to avoid over-
 * reserving. Goal: keep CLS near 0 by reserving real-section space.
 */
export default function LoadingFallback() {
  return <div className='w-full min-h-[400px] bg-base-200/30 animate-pulse' />
}
